import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import parseResponseToOptions, { parseVMDetailsOptions } from '../../utils/parseResponseToOptions';
import CreateVMPGMapping from './component';

class CreateVMPGMappingContainer extends Component {
  constructor() {
    super();
    this.state = {
      corporateId: null,
      paymentConfigId: null,
      vmIdColl: [],
      loading: true,
      vmLoading: true,
      vmList: [],
      corporateLoading: true,
      corporateList: [],
      gatewayLoading: true,
      paymentGatewayList: [],
      paymentConfigListLoading: true,
      paymentConfigList: []
    };
  }
  componentDidMount() {
    this.props.getDataFromAPI(
      '/vendingmachines/su/all',
      'GET',
      undefined,
      response => {
        this.setState({
          vmList: parseVMDetailsOptions(response.list),
          vmLoading: false,
          loading: false
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch vending machine list');
        this.setState({ loading: false, vmLoading: false });
      }
    );

    this.props.getDataFromAPI(
      '/vendingmachines/corporates',
      'GET',
      undefined,
      response => {
        this.setState({
          corporateList: parseResponseToOptions(response.list),
          corporateLoading: false,
          loading: false
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch corporate list');
        this.setState({ loading: false, corporateLoading: false });
      }
    );

    this.props.getDataFromAPI(
      '/vendingmachines/payments/gateways',
      'GET',
      undefined,
      response => {
        this.setState({
          paymentGatewayList: parseResponseToOptions(response.list),
          loading: false,
          gatewayLoading: false
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch gateway list');
        this.setState({ loading: false, gatewayLoading: false });
      }
    );
  }

  onChangeOfVM = (event, data) => {
    this.setState({ vmIdColl: data.value });
  };

  onChangeOfCorporateId = (event, data) => {
    this.setState({ corporateId: data.value });
  };

  onChangeOfPaymentGateway = (event, data) => {
    this.props.getDataFromAPI(
      `/vendingmachines/payments/${data.value}/configs`,
      'GET',
      undefined,
      response => {
        this.setState({
          paymentConfigList: parseResponseToOptions(response.list),
          loading: false,
          paymentConfigListLoading: false,
          paymentConfigId: null
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch gateway list');
        this.setState({ loading: false, paymentConfigListLoading: false });
      }
    );
  };

  onChangeOfPaymentConfig = (event, data) => {
    this.setState({ paymentConfigId: data.value });
  };

  handleSubmit = () => {
    // set loading true
    this.setState({ loading: true });

    const { corporateId, paymentConfigId, vmIdColl } = this.state;

    const payload = {
      corporateId,
      paymentConfigId,
      vmIdColl
    };

    if (!corporateId) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Select a corporate');
    }
    if (!paymentConfigId) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Select a payment config');
    }
    if (!vmIdColl.length) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Select Vending machine');
    }

    this.props.getDataFromAPI(
      '/vendingmachines/vm-corp-payment-mappings',
      'POST',
      payload,
      response => {
        toastr.success('Successful', 'Added new mapping');
        this.setState({ loading: false });
        return this.props.history.push('/vendingmachines/');
      },
      err => {
        this.setState({ loading: false });
        toastr.error('Failed', err.message);
      }
    );
  };

  handleBack = () => {
    return this.props.history.push('/vendingmachines');
  };

  render() {
    return (
      <CreateVMPGMapping
        loading={this.state.loading}
        vmLoading={this.state.vmLoading}
        vmList={this.state.vmList}
        corporateLoading={this.state.corporateLoading}
        corporateList={this.state.corporateList}
        gatewayLoading={this.state.gatewayLoading}
        paymentGatewayList={this.state.paymentGatewayList}
        paymentConfigListLoading={this.state.paymentConfigListLoading}
        paymentConfigList={this.state.paymentConfigList}
        onChangeOfCorporateId={this.onChangeOfCorporateId}
        onChangeOfPaymentConfig={this.onChangeOfPaymentConfig}
        onChangeOfPaymentGateway={this.onChangeOfPaymentGateway}
        onChangeOfVM={this.onChangeOfVM}
        handleBack={this.handleBack}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

export default withRouter(
  connect(null, {
    getDataFromAPI
  })(CreateVMPGMappingContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/VMPGMapping/container.jsx